<template>
  <div
    :id="popperId"
    class="badge badge-light border mr-1 mb-1"
  >
    {{ shipment.trackingNumber || shipment.shipmentId | truncate(20) }}
    <span v-if="shipment.status" class="ml-1">
      <span :class="'badge badge-' + statusVariant(shipment.status)">{{ shipment.status }}</span>
    </span>

    <b-popover container="body" boundary="viewport" :target="popperId" triggers="hover" placement="left">
      <template #title>
        Shipment
        <span v-if="shipment.carrierCode" class="text-muted ml-1">{{ shipment.carrierCode }}</span>
        <span v-if="shipment.serviceCode" class="text-muted ml-1">/ {{ shipment.serviceCode }}</span>
      </template>

      <div>
        <div class="mb-2">
          <div v-if="shipment.trackingNumber"><b>Tracking:</b> {{ shipment.trackingNumber }}</div>
          <div v-if="shipment.createDate"><b>Created:</b> {{ shipment.createDate | moment('MMM Do YY, h:mm a') }}</div>
          <div v-if="shipment.status"><b>Status:</b> {{ shipment.status }}</div>
        </div>

        <div class="mb-2" v-if="shipment.dimensions || shipment.weight || shipment.grossWeight">
          <div v-if="shipment.dimensions && (shipment.dimensions.length || shipment.dimensions.width || shipment.dimensions.height)">
            <b>Dimensions:</b>
            {{ shipment.dimensions.length }} x {{ shipment.dimensions.width }} x {{ shipment.dimensions.height }}
            <span v-if="shipment.dimensions.units">{{ shipment.dimensions.units }}</span>
          </div>
          <div v-if="shipment.weight && shipment.weight.value">
            <b>Weight:</b> {{ shipment.weight.value }} {{ shipment.weight.units }}
          </div>
          <div v-if="shipment.grossWeight && shipment.grossWeight.value">
            <b>Gross Weight:</b> {{ shipment.grossWeight.value }} {{ shipment.grossWeight.units }}
          </div>
        </div>

        <div v-if="shipment.shipmentItems && shipment.shipmentItems.length">
          <b>Items:</b>
          <table class="table table-sm table-bordered mt-1 mb-0 shipments-preview-table">
            <thead class="thead-dark">
              <tr>
                <th>SKU</th>
                <th>Name</th>
                <th>Qty</th>
                <th>Unit $</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in shipment.shipmentItems" :key="i">
                <td>{{ item.sku }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.unitPrice != null ? '$' + item.unitPrice.toFixed(2) : '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: 'ShipmentBadge',
  props: {
    shipment: {
      type: Object,
      required: true
    },
    uid: {
      type: String,
      required: true
    }
  },
  computed: {
    popperId() {
      return 'shipment-badge-' + this.uid;
    }
  },
  methods: {
    statusVariant(status) {
      var variants = {
        Created: 'success',
        PendingConfirmation: 'warning',
        Voided: 'danger',
        Cancelled: 'danger'
      };
      return variants[status] || 'secondary';
    }
  }
};
</script>
